/**
 * Platform Registry
 * Central registry of all supported social platforms
 */

import type { Platform, PlatformId } from '../types';

import { twitter } from './twitter';
import { facebook } from './facebook';
import { pinterest } from './pinterest';
import { reddit } from './reddit';
import { linkedin } from './linkedin';
import { vk } from './vk';
import { ok } from './ok';
import { weibo } from './weibo';
import { qzone } from './qzone';
import { line } from './line';
import { kakao } from './kakao';
import { naver } from './naver';
import { messenger } from './messenger';
import { tumblr } from './tumblr';
import { plurk } from './plurk';
import { whatsapp } from './whatsapp';
import { telegram } from './telegram';
import { email } from './email';
import { hatena } from './hatena';
import { threads } from './threads';
import { x } from './x';
import { copylink } from './copylink';
import { snapchat } from './snapchat';
import { instagram } from './instagram';
import { discord } from './discord';
import { viber } from './viber';
import { classroom } from './classroom';

/** All registered platforms */
export const platforms: Record<PlatformId, Platform> = {
  twitter,
  facebook,
  pinterest,
  reddit,
  linkedin,
  vk,
  ok,
  weibo,
  qzone,
  line,
  kakao,
  naver,
  messenger,
  tumblr,
  plurk,
  whatsapp,
  telegram,
  email,
  hatena,
  threads,
  x,
  copylink,
  snapchat,
  instagram,
  discord,
  viber,
  classroom,
};

/** Get platform by ID */
export function getPlatform(id: PlatformId): Platform | undefined {
  return platforms[id];
}

/** Get multiple platforms by IDs */
export function getPlatforms(ids: PlatformId[]): Platform[] {
  return ids.map(id => platforms[id]).filter((p): p is Platform => p !== undefined);
}

/** Check if platform ID is valid */
export function isPlatformId(id: string): id is PlatformId {
  return id in platforms;
}

/** Get all platform IDs */
export function getAllPlatformIds(): PlatformId[] {
  return Object.keys(platforms) as PlatformId[];
}

export {
  twitter,
  facebook,
  pinterest,
  reddit,
  linkedin,
  vk,
  ok,
  weibo,
  qzone,
  line,
  kakao,
  naver,
  messenger,
  tumblr,
  plurk,
  whatsapp,
  telegram,
  email,
  hatena,
  threads,
  x,
  copylink,
  snapchat,
  instagram,
  discord,
  viber,
  classroom,
};

